import * as React from 'react'
import spinnerIcon from '$icons/Spinner.svg'
import { Icon } from '../Icon'
import {
  SpinnerWrapper,
  HorizontalSpinnerWrapper,
  SpinnerBounce1,
  SpinnerBounce2,
} from '$views/components/Spinner/Spinner.style'

interface Props {
  horizontal?: boolean
}

export const Spinner: React.SFC<Props> = ({ horizontal }) => {
  if (horizontal) {
    return (
      <HorizontalSpinnerWrapper>
        <SpinnerBounce1 />
        <SpinnerBounce2 />
        <div />
      </HorizontalSpinnerWrapper>
    )
  }

  return (
    <SpinnerWrapper flex alignItems="center" justify="center">
      <Icon content={spinnerIcon} size="xl" />
    </SpinnerWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Spinner/Spinner.tsx